import axios from 'axios';
import store from '@/store';
import {
  mutationTypes,
  persistedTypes,
} from '@/store/types';
import cookies from 'js-cookie';
import router from '@/router';

const xhr = axios.create();

const requestHandler = (config) => {
  const token = store.state.session.token;
  const { suppressLoader } = config;

  if (suppressLoader !== true) {
    store.commit(mutationTypes.global.addProcess);
  }

  if (token) {
    /* eslint-disable no-param-reassign */
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};
const responseHandler = (resp) => {
  const { config: { suppressLoader } } = resp;

  if (suppressLoader !== true) {
    store.commit(mutationTypes.global.removeProcess);
  }

  return resp;
};
const errorHandler = (err) => {
  const { config: { suppressLoader } } = err;

  if (suppressLoader !== true) {
    store.commit(mutationTypes.global.removeProcess);
  }

  if (!err.response) {
    return Promise.reject(err);
  }

  const { response: { status, data } } = err;
  if (status === 401) {
    if (data) {
      store.commit(mutationTypes.global.setError, data);
    }
    cookies.set(persistedTypes.token.value, '');
    router.push('login');
  }

  return Promise.reject(err);
};

xhr.interceptors.request.use(requestHandler, errorHandler);
xhr.interceptors.response.use(responseHandler, errorHandler);

export default xhr;



// WEBPACK FOOTER //
// ./src/modules/xhr.js